/**
 * App — punto de entrada de la aplicación.
 * Gestiona el estado de autenticación: Login vs AppShell.
 */

import { SessionProvider, useSession } from './context/SessionContext.jsx'
import Login    from './components/Login.jsx'
import AppShell from './components/AppShell.jsx'

function Router() {
  const { isAuthenticated } = useSession()
  return isAuthenticated ? <AppShell /> : <Login />
}

export default function App() {
  return (
    <SessionProvider>
      <Router />
    </SessionProvider>
  )
}
